module.exports = __webpack_public_path__ + "static/media/flooring_lcs_60yd_n.b863ade8.csv";